import { CloneObjectPipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { TabsContainerComponent } from '@adaptiva/widgets/tabs';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { BlacklistPropertiesComponentModule } from '../blacklist-properties';
import { ContentOverrideForRepairPropertiesComponentModule } from '../content-override-for-repair-properties';
import { ContentOverrideForUninstallationPropertiesComponentModule } from '../content-override-for-uninstallation-properties';
import { ContentPropertiesComponentModule } from '../content-properties';
import { CustomPropertiesComponentModule } from '../custom-properties';
import { CveMappingPropertiesComponentModule } from '../cve-mapping-properties';
import { ExtensionsPropertiesComponentModule } from '../extensions-properties';
import { FormAuthoringModule } from '../form-authoring';
import { GeneralPropertiesComponentModule } from '../general-properties';
import { HousekeepingPropertiesComponentModule } from '../housekeeping-properties';
import { IconPropertiesComponentModule } from '../icon-properties';
import { InstallTimePropertiesComponentModule } from '../install-time-properties';
import { MediaDetectionPropertiesComponentModule } from '../media-detection-properties';
import { MetadataHistoryObjectTableComponentModule } from '../metadata-history-object-table';
import { ProductPropertiesComponentModule } from '../product-properties';
import { RealTimePropertiesComponentModule } from '../real-time-properties';
import { RelationshipsPropertiesComponentModule } from '../relationships-properties';
import { RiskPropertiesComponentModule } from '../risk-properties';
import { RulesPropertiesComponentModule } from '../rules-properties';
import { TrackingPropertiesComponentModule } from '../tracking-properties';
import { UserPortalPropertiesComponentModule } from '../user-portal-properties';
import { AuthoringPropertyTabsComponent } from './authoring-property-tabs.component';
import { ForCustomizationPipe, HasTabPipe } from './pipes';

const AUTHORING_PROPERTIES_CARDS: Type<NgModule>[] = [
	BlacklistPropertiesComponentModule,
	ContentOverrideForRepairPropertiesComponentModule,
	ContentOverrideForUninstallationPropertiesComponentModule,
	ContentPropertiesComponentModule,
	CustomPropertiesComponentModule,
	CveMappingPropertiesComponentModule,
	ExtensionsPropertiesComponentModule,
	FormAuthoringModule,
	GeneralPropertiesComponentModule,
	HousekeepingPropertiesComponentModule,
	IconPropertiesComponentModule,
	InstallTimePropertiesComponentModule,
	MediaDetectionPropertiesComponentModule,
	ProductPropertiesComponentModule,
	RealTimePropertiesComponentModule,
	RelationshipsPropertiesComponentModule,
	RiskPropertiesComponentModule,
	RulesPropertiesComponentModule,
	TrackingPropertiesComponentModule,
	UserPortalPropertiesComponentModule,
];

const DIRECTIVES: Type<any>[] = [TemplateMarkerDirectiveModule];

const PIPES: Type<any>[] = [
	CloneObjectPipe,
	HasTabPipe,
	ForCustomizationPipe,
];

@NgModule({
	imports: [
		CommonModule,
		ContainerComponentModule,
		CardComponentModule,
		TextComponentModule,
		TabsContainerComponent,
		MetadataHistoryObjectTableComponentModule,
		AUTHORING_PROPERTIES_CARDS,
		DIRECTIVES,
		PIPES,
	],
	declarations: [AuthoringPropertyTabsComponent],
	exports: [AuthoringPropertyTabsComponent]
})
export class AuthoringPropertyTabsComponentModule {

}
